export interface AyaDuration {
  months?: number;
  weeks?: number;
}
